export default __webpack_public_path__ + "static/nude1-37420e2123e0796e5306923845554658.jpg";